import React from 'react';

import styled from 'styled-components';

interface Props {
  children: React.ReactNode;
}

export const MainContentContainer = ({
  children,
  ...other
}: Props): JSX.Element => (
  <StyledContentDiv {...other}>{children}</StyledContentDiv>
);

const StyledContentDiv = styled.div.attrs({
  className: 'container',
})`
  padding-top: 2rem;
  padding-bottom: 3rem;
`;
